import { Booking } from 'shared-types/booking';
import { RoomSlots, SlotState, Slot } from 'shared-types/roomSlots';

import { add24Hours } from './handle24hours';

export const getAvailableNextSlot = async (
  booking: Booking,
  roomSlots: RoomSlots,
): Promise<Slot | null> => {
  const { endHour, startHour } = booking;
  const { slots } = roomSlots;

  const sortedSlots = slots
    .map((slot) => {
      const { startHour, endHour } = slot;
      return {
        ...slot,
        startHour: add24Hours(startHour),
        endHour: add24Hours(endHour),
      };
    })
    .sort((a, b) => a.startHour - b.startHour);

  const currentTimeMinutes = new Date().getHours() * 60 + new Date().getMinutes();

  const currentSlotIndex = sortedSlots.findIndex(
    (slot) =>
      slot.endHour === endHour ||
      (slot.startHour <= startHour && slot.endHour >= endHour) ||
      (slot.startHour <= add24Hours(currentTimeMinutes) &&
        slot.endHour >= add24Hours(currentTimeMinutes)),
  );

  if (currentSlotIndex === -1 || currentSlotIndex === sortedSlots.length - 1) {
    return null;
  }

  const nextSlot = sortedSlots[currentSlotIndex + 1];
  if (nextSlot.state === SlotState.AVAILABLE) {
    return nextSlot;
  }
  return null;
};

export const getSlotPrices = (slot: Slot) => {
  const { price, pricePerPerson } = slot;

  return {
    price: price || pricePerPerson,
    pricePerPerson: pricePerPerson || price,
  };
};
